import CommonValidation from '../../../utils/common.validation';

class Validation {
  static formValidate = (type, value, checkValue) => {
    switch (type) {
      case 'lastName':
        return CommonValidation.requiredValue(value);
      case 'email':
        return CommonValidation.requiredEmail(value);
      case 'password':
        return CommonValidation.requiredPassword(value);
      case 'passwordCheck':
        return CommonValidation.requiredPasswordCheck(value, checkValue);
      default:
        return '';
    }
  };
}

export default Validation;
